# GraphQL mutation to update a slack automation
#import "../fragments/open-lead-slack-message-fragment.graphql"

mutation UpdateOpenLeadSlackMessage(
    $openLeadSlackMessage: UpdateOpenLeadSlackMessageInputFieldInput!
) {
    updateOpenLeadSlackMessage(input: {openLeadSlackMessage: $openLeadSlackMessage}) {
        openLeadSlackMessage {
            ...SlackMessageAutomation
        }
    }
}
